import { useEffect } from "react";
import { useImmer } from "use-immer";
import { errorMessage } from "../../../utils";
import { getCustomerStampCardDetails } from "../api";

export const useCustomerStampCardDetails = ({ customerId, stampCardId }) => {
  const [state, setState] = useImmer({
    isLoading: true,
    data: {
      id: null,
      name: "",
      cycle: 0,
      stamps_earned: 0,
      total_stamps: 0,
      cycle_validity: 0,
      started_on: "",
      ended_on: "",
      status: 0,
      status_label: "",
      transactions: [],
    },
  });

  // Fetch stamp card details
  const fetchStampCardDetails = async () => {
    if (!customerId || !stampCardId) return;

    try {
      setState((draft) => {
        draft.isLoading = true;
      });

      const res = await getCustomerStampCardDetails(customerId, stampCardId);

      if (res.success) {
        setState((draft) => {
          draft.data = res.data;
          draft.isLoading = false;
        });
      }
    } catch (err) {
      errorMessage(
        err?.response?.data?.message || "Failed to fetch stamp card details",
      );
      setState((draft) => {
        draft.isLoading = false;
      });
    }
  };

  // Initial load
  useEffect(() => {
    fetchStampCardDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerId, stampCardId]);

  return {
    state,
    fetchStampCardDetails,
  };
};
